module.exports = __webpack_public_path__ + "img/ic_medium_video-active.838f7dcd.svg";